<template>
  <div class="center">
      <vs-dialog not-close prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Filtro <strong>{{name ? name : 'No asignado'}}</strong>
          </h4>
        </template>
        <div class="con-form">
          <!-- <vs-checkbox 
            :indeterminate="dataRowFilter.length == dataList.length" 
            v-model="allCheck" 
            @change="$emit('check-all-filter')"
          >
              check all
            </vs-checkbox> -->
          <div class="center con-checkbox">
            <vs-checkbox v-for="(data) in dataList" :val="data" v-model="dataRowFilter" :key="data">
              {{data}}
            </vs-checkbox>
          </div>
        </div>

        <template #footer>
          <div class="footer-dialog">
            <vs-button block @click="$emit('close-filter')">
              Cerrar
            </vs-button>
          </div>
        </template>
      </vs-dialog>
  </div>
</template>
<script>
  export default {
      props:{
        active : {
          default : true,
          type: Boolean
        },
        dataList:{
          default : () => [],
          type: Array
        },
        dataRowFilter:{
          default : () => [],
          type: Array
        },
        name:{
            default: null,
            type: String
        },
      },
      data(){
        return{
          allCheck:false
        }
      }
    }
</script>
<style scoped lang="sass">
  // getColor(vsColor, alpha = 1)
  //     unquote("rgba(var(--vs-"+vsColor+"), "+alpha+")")
  // getVar(var)
  //     unquote("var(--vs-"+var+")")
  // .not-margin
  //   margin 0px
  //   font-weight normal
  //   padding 10px
  // .con-form
  //   width 100%
  //   .flex
  //     display flex
  //     align-items center
  //     justify-content space-between
  //     a
  //       font-size .8rem
  //       opacity .7
  //       &:hover
  //         opacity 1
  //   .vs-checkbox-label
  //     font-size .8rem
  //   .vs-input-content
  //     margin 10px 0px
  //     width calc(100%)
  //     .vs-input
  //       width 100%
  // .footer-dialog
  //   display flex
  //   align-items center
  //   justify-content center
  //   flex-direction column
  //   width calc(100%)
  //   .new
  //     margin 0px
  //     margin-top 20px
  //     padding: 0px
  //     font-size .7rem
  //     a
  //       color getColor('primary')
  //       margin-left 6px
  //       &:hover
  //         text-decoration underline
  //   .vs-button
  //     margin 0px
  </style>